import { useEffect } from "react";
import { useGlobalState } from "../../contexts/use-global-state-context";
import useUserReferences from "utilities/hooks/domain/user-references/use-user-references";
import { useAtom } from "jotai";
import ReferencePanelContextAtom from "utilities/atoms/bookview/reference-panel-context-atom";

const useBuildReferencePanel = () => {
    const [, setReferencePanelContext] = useAtom(ReferencePanelContextAtom);

    const {
        globalState: { currentIdentity },
    } = useGlobalState();

    const currentUserId = currentIdentity?.userId();
    const currentUserRoleId = currentIdentity?.getCurrentUserRole()?.id;
    const referencesEnabled = currentIdentity?.hasActiveSubscription() ?? false;

    const {
        errors,
        loaded,
        loading,
        resultObject: {
            currentSection,
            currentSectionId,
            currentUserReferenceId,
            userReferences,
        },
    } = useUserReferences(currentUserId, currentUserRoleId, referencesEnabled);

    useEffect(() => {
        setReferencePanelContext((prevContext) =>
            prevContext.with({
                currentSection,
                currentSectionId,
                currentUserReferenceId,
                errors,
                loaded,
                loading,
                userReferences,
            })
        );
    }, [
        currentSection,
        currentSectionId,
        currentUserReferenceId,
        errors,
        loaded,
        loading,
        setReferencePanelContext,
        userReferences,
    ]);

    return {
        loaded,
        loading,
    };
};

export default useBuildReferencePanel;
